<template>
    <div class="shadow table-div" style="border: 1px solid #a8a8a8; border-radius: 10px; overflow:hidden">
        <table class="table table-border">
            <thead>
                <th>Vehicle Type / Months </th>
                <th v-for="month in months">{{month}}</th>
            </thead> 
            <tbody v-if="vehicleType" v-for="vehicleType in vehicleTypes">
                <td>{{vehicleType}}</td>
                <td v-for="(count , index) in data[vehicleType]">{{count ? numberWithCommas(count) : 0}}</td>
            </tbody>           
        </table>
    </div>
</template>

<script>
import qs from 'qs';

export default {
    data(){
        return {
            months : [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            vehicleTypes : null,
            data : null,
            year : new Date().getFullYear()
        }
        
    },
    props : ['filter', 'update'],
    mounted(){

    },
    watch : {
        'update' : {
            handler : 'getData',
        }
    },
    methods : {
        getData(){
            console.log('hi');
            this.$http.get(`/api/vehicle/stats/month${qs.stringify(this.filter, {skipNulls:true, addQueryPrefix:true})}`)
            .then((resp)=>{
                let data = resp.data.data;
                this.vehicleTypes = Object.keys(data);
                this.data = data;
            })
        },
        numberWithCommas(x) {
            return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    }
}
</script>

<style scoped>
    .table-div{
        display: block;
        overflow: scroll;
    }
</style>